<template>
  <div class="header-container">
    <div class="header-container__main">
      <h1 class="header-title">Bienvenue au système Cardex</h1>
      <span title="Settings" :class="getSettingsIconClass"
            @click="showOptions = !showOptions">
      </span>
      <transition name="modal-fade">
        <div v-if="showOptions" class="header__modal-container">
          <OptionsPopup
              :tabindex="0"
              @close="showOptions = false"
              @keydown.esc="showOptions = false"/>
        </div>
      </transition>
    </div>
    <div class="header-container__main">
      <div class="row pt5 pb5 border">
        <div class="col-2">
          <Button @click="choixProfil">
            Choix du profil
          </Button>
        </div>
        <div class="col left">{{ profilInfo }}</div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios';
import {mapGetters} from "vuex";
import OptionsPopup from './OptionsPopup.vue';

export default {
  name: "FonctionsBase",
  components: {
    OptionsPopup,
  },
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Menu");

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$store
        .dispatch('cardex/obtenirProfilInfoAction')
        .then((res) => {
          this.assignerInformationUtilisateur(res);
        });
  },
  data() {
    return {
      profilInfo: null,
      showOptions: false,
    };
  },
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil'
    }),
    getSettingsIconClass() {
      let cls = 'deactivated';
      if (this.showOptions) cls = 'activated';
      return 'material-icon icon-settings icon-settings__' + cls;
    }
  },
  methods: {
    getCurrentDateTime() {
      return new Date();
    },
    assignerInformationUtilisateur(res) {
      this.profilInfo = res.data.nomIntervenant + ", " + res.data.prenomIntervenant + " (" +
          res.data.codeProfilUtilisateur + ", " + res.data.nomGroupeSecurite + "), "
          + res.data.siteOrigine + ", " + this.profil.secteurAfficher;
    },
    choixProfil() {
      this.$store.dispatch('cardex/ajouterEvenementLogoutAction');
      this.$router.push({name: "choix-profil"});
    },
  },
}

</script>